import React from 'react';
import {Animated} from 'react-native';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import {RFValue} from 'react-native-responsive-fontsize';
import {useTheme} from 'styled-components/native';
import {PPVeiculoDTO} from '../../../../../../dtos/ProntoPagueiDTO';
import {
  Card,
  CardInfo,
  CardModel,
  CardDetails,
  CardError,
  SkeletonLine,
} from './styles';

interface VehicleCardProps {
  veiculo: PPVeiculoDTO | null;
  veiculoLoading: boolean;
  veiculoError: string | null;
  bothInputsFilled: boolean;
  cardAnim: Animated.Value;
  pulseAnim: Animated.Value;
}

export function VehicleCard({
  veiculo,
  veiculoLoading,
  veiculoError,
  bothInputsFilled,
  cardAnim,
  pulseAnim,
}: VehicleCardProps) {
  const theme = useTheme();

  const isLoadingState = veiculoLoading || (!veiculo && !veiculoError);
  const cardState = isLoadingState ? 'loading' : veiculoError ? 'error' : 'success';

  function renderContent() {
    if (isLoadingState) {
      return (
        <Animated.View
          style={{
            opacity: pulseAnim,
            flexDirection: 'row',
            alignItems: 'center',
            gap: RFValue(12),
            flex: 1,
          }}>
          <MaterialCommunityIcons
            name="car-outline"
            size={RFValue(28)}
            color={theme.colors.placeholder}
          />
          <CardInfo>
            <SkeletonLine width="62%" height={13} />
            <SkeletonLine width="38%" height={10} style={{marginTop: RFValue(6)}} />
          </CardInfo>
        </Animated.View>
      );
    }

    if (veiculoError) {
      return (
        <>
          <MaterialCommunityIcons
            name="alert-circle-outline"
            size={RFValue(20)}
            color={theme.colors.attention}
          />
          <CardError>{veiculoError}</CardError>
        </>
      );
    }

    if (veiculo) {
      return (
        <>
          <MaterialCommunityIcons
            name="car-outline"
            size={RFValue(28)}
            color={theme.colors.blue}
          />
          <CardInfo>
            <CardModel>
              {veiculo.modelo ?? 'Veículo localizado' } {veiculo.ano}
            </CardModel>
            <CardDetails>
              {veiculo.placa}
              {veiculo.uf && veiculo.uf.length > 0 && ' · ' + veiculo.uf}
            </CardDetails>
          </CardInfo>
          <MaterialCommunityIcons
            name="check-circle-outline"
            size={RFValue(18)}
            color={theme.colors.blue}
          />
        </>
      );
    }

    return null;
  }

  return (
    <Animated.View
      style={{
        opacity: cardAnim,
        transform: [
          {
            translateY: cardAnim.interpolate({
              inputRange: [0, 1],
              outputRange: [10, 0],
            }),
          },
        ],
      }}>
      {bothInputsFilled && (
        <Card state={cardState}>
          {renderContent()}
        </Card>
      )}
    </Animated.View>
  );
}
